import React from 'react';
import { Slide, toast, ToastContainer, ToastContentProps } from 'react-toastify';
import { ErrorToast, SuccessToast } from '@hz-design-system/web-ui';
import 'react-toastify/dist/ReactToastify.css';

import Classes from './ToastNotification.module.scss';

export const HomepageToastContainer = () => (
  <ToastContainer
    position="bottom-center"
    theme="light"
    hideProgressBar
    autoClose={5000}
    draggable={false}
    closeButton={false}
    className={Classes.root}
    newestOnTop
    transition={Slide}
    closeOnClick={false}
    limit={1}
    progressClassName={Classes.progressBar}
    toastClassName={`${Classes.toast} ${Classes.message}`}
  />
);

type TToastNotificationProps = {
  type: 'success' | 'error';
  description: string;
  delay?: number;
};

const ToastNotification = ({ type, description, delay = 0 }: TToastNotificationProps) => {
  if (type === 'success') {
    toast(
      ({ closeToast }: ToastContentProps) => (
        <SuccessToast icon="checkmark-circle" onClose={closeToast}>
          {description}
        </SuccessToast>
      ),
      {
        delay: delay,
      },
    );
  }

  if (type === 'error') {
    toast(
      ({ closeToast }: ToastContentProps) => (
        <ErrorToast icon="alert" onClose={closeToast}>
          {description}
        </ErrorToast>
      ),
      {
        delay: delay,
      },
    );
  }
};

export default ToastNotification;

export const dismissToast = toast.dismiss;
